
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { sharedState } from '../../framework/state';
import { VendorContract } from '../../../common/application/model/VendorContract';
import { PAGE_SIZE } from '../../../common/framework/constants';
import { getResource, getResourcesNew } from '../../framework/client/resource';
import { ValidationProvider } from 'vee-validate';
import { getFieldNameFromVModelProperty } from '../../framework/util/component_util';
import { ApplicationResource } from '../../../common/application/enumeration/ApplicationResource';

@Component({
    components: { ValidationProvider },
})
export default class VendorContractSelect extends Vue {
    @Prop(String) name!: string;
    @Prop(String) vendorNumber!: string;
    @Prop(String) vehicleContractId!: string;
    @Prop(String) vehicleRegistrationNumber!: string;
    @Prop(String) readonly value!: string;
    @Prop(Boolean) readonly required!: boolean;
    @Prop(Boolean) readonly disabled!: string;
    @Prop(Boolean) readonly preSelect!: string;

    shared = sharedState;
    local = {
        rows: [] as VendorContract[],
        total: 0,
        loading: false,
        page: 1,
        perPage: PAGE_SIZE,
        typed: '',
        selectedId: undefined as string | undefined,
    };

    objects: VendorContract[] = [];

    async mounted() {
        await this.loadOptions();
    }

    private async loadOptions() {
        const parameters = new Map<string, string>();
        if (this.vendorNumber) {
            parameters.set('vendorNumber', this.vendorNumber);
        }
        if (this.vehicleContractId) {
            parameters.set('vehicleContractId', this.vehicleContractId);
        }

        if (this.vehicleRegistrationNumber) {
            parameters.set('vehicleRegistrationNumber', this.vehicleRegistrationNumber);
        }

        this.objects = (await getResourcesNew(ApplicationResource.VENDOR_CONTRACT, -1, parameters)) as VendorContract[];

        if (this.objects.length === 1 && this.preSelect) {
            this.local.selectedId = this.objects[0].id;
        }
    }

    @Watch('value')
    async valueChange(newValue: string) {
        this.local.selectedId = newValue;
        if (this.local.selectedId) {
            this.local.typed = (await getResource<VendorContract>(
                ApplicationResource.VENDOR_CONTRACT,
                this.local.selectedId,
            ))!!.vehicleRegistrationNumber;
        } else {
            this.local.typed = '';
        }
    }

    @Watch('local.selectedId')
    async selectedIdChange(newValue: string) {
        this.$emit('input', newValue);
    }

    @Watch('vendorNumber')
    async vendorNumberChange() {
        this.local.typed = '';
        await this.loadOptions();
    }

    @Watch('vehicleContractId')
    async vehicleContractIdChange() {
        this.local.typed = '';
        await this.loadOptions();
    }

    get filteredObjects() {
        return [
            {
                id: undefined as undefined | string,
                vehicleRegistrationNumber: '-',
            },
        ].concat(
            this.objects
                .filter((o) => {
                    return (
                        o.vehicleRegistrationNumber &&
                        o.vehicleRegistrationNumber.toString().toLowerCase().indexOf(this.local.typed.toLowerCase()) !=
                            -1
                    );
                })
                .map((o) => {
                    return {
                        id: o.id as undefined | string,
                        vehicleRegistrationNumber: o.vehicleRegistrationNumber,
                    };
                }),
        );
    }

    getFieldName() {
        return getFieldNameFromVModelProperty(this);
    }
}
